import { apiRoutes } from "../../config"
import { api } from "../../utils/lib/api"



export const getPricelists = async (entId) => {
    try {
        const url = `${apiRoutes.prices.getPricelists}/${entId}/pricelists`
        return await api.get(url)
    } catch (error) {
        console.log(error)
        throw new Error(error)
    }
}


